import React from 'react';

import JobsListPage from '../../../js/pages/JobsListPage';
import dataScientist from '../../../js/pages/JobsListPage/dataScientistJobs';

const Page = () => <JobsListPage role={dataScientist} />;

export default Page;
